export default __webpack_public_path__ + "static/media/CapaEdit.8f0a00ce.svg";